export const shouldForwardProp = <CustomProps extends Record<string, unknown>>(
	props: Array<keyof CustomProps>,
	prop: PropertyKey
): boolean => !props.includes(prop as string);
